import { VApp } from 'vuetify/lib/components/VApp';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.lpuAddressList.length || _setup.isVisibleOtherCountriesOfWork
    ? _c(
        VApp,
        {
          class: {
            "px-2 pt-2": _setup.externalDataStore.isMobile,
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "rounded doctor-page-lpu-list--redesign doctor-page-lpu-list",
              class: { "pa-2": _setup.externalDataStore.isMobile },
              attrs: { id: "doctor-page-lpu-list" },
            },
            [
              _vm.lpuAddressList.length
                ? _c(_setup.DoctorPageLpuListHeader)
                : _vm._e(),
              _vm._v(" "),
              _c(_setup.DoctorPageLpuListBody),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }